import React, { useEffect, useState } from 'react';
import styles from './Toast.module.scss';

export const Toast = ({ message, isVisible, onHide }) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
      const timer = setTimeout(() => {
        setShouldRender(false);
        setTimeout(onHide, 300); // Wait for fade out animation to complete
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  if (!shouldRender) return null;

  return (
    <div className={`${styles.toast} ${isVisible ? styles.show : styles.hide}`}>{message}</div>
  );
};
